import apolloClient from "../apolloClient";
import { CREATE_EVENT_BOOKING, GET_EVENT_BOOKINGS } from "./graphql";
import { mapModelToBooking } from "./helper";
class EventBookingService {
	async book(model, customerId) {
		await apolloClient.mutate({
			mutation: CREATE_EVENT_BOOKING,
			variables: {
				customerBooking: mapModelToBooking(model, customerId),
			},
		});
	}

	async list() {
		const { data } = await apolloClient.query({
			query: GET_EVENT_BOOKINGS,
		});

		return data.myEventBookings.nodes;
	}
}

export default new EventBookingService();
